// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__ICmlb","crumbProduct":"Breadcrumbs_crumbProduct__PhBzr"};